import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable()
export class JsonService {
  constructor(private readonly _http: HttpClient) {}

  public getJsonValues(): Observable<any> {
    const jsonUrl = "../../../main/assets/calcJson/Deforestation1.json";
    return this._http.get(jsonUrl);
  }

  public getActivityJson(): Observable<any> {
    const activityJson = "../assets/activity.json";

    return this._http.get(activityJson);
  }

  public getImageConfigJson(): Observable<any> {
    const imageConfigJson = "../../../assets/imageConfig.json";

    return this._http.get(imageConfigJson);
  }
}
